import { THEME_CONTEXT } from 'es/app/theme/theme';
import { useContext } from 'react';

export const useTheme = () => {
    const themeContext = useContext(THEME_CONTEXT);
    if (!themeContext) {
        throw new Error(`Unable to find theme context. Is there a wrapping <ThemeProvider />?`);
    }
    return themeContext;
};
